<template>
    <div class="mx-auto flex-fill screen-container">
        <div class="mb-4 text-gray-900">
            <div class="fw-bold fs-14 mb-2 step-indicator">STEP {{ currentStep }} OF 3</div>
            <h1 class="ff-montserrat mb-3 welcome-title">Welcome{{ userName ? `, ${userName}!` : '' }}</h1>
            <p class="text-gray-600 fs-6 mb-3 pr-3 welcome-description">You're about to experience the best proofing software for
                high velocity creative teams. Your free account is designed to make sure you get the
                best of everything from Ashore.</p>
        </div>
        <div class="shadow-base bg-white rounded mb-4 text-gray-900">
            <div class="py-3 px-32 features-list">
                <h6 class="fw-bold mb-12" >Your Free Account Includes:</h6>
                <ul class="d-flex flex-column gap-2 list-unstyled mb-0">
                    <li v-for="(item, index) in featuresIncludes" :key="index" class="d-flex align-items-center gap-2">
                        <div class="icon flex-shrink-0">
                            <img src="/img/check.svg" class="d-block" width="16" alt="Check">
                        </div>
                        <span class="fs-14 d-block">{{ item }}</span>
                    </li>
                </ul>
            </div>

            <div class="py-3 px-32 text-gray-900">
                <h6 class="fw-bold mb-12">Upgrade to Unlock:</h6>
                <ul class="d-flex flex-column gap-2 list-unstyled mb-0">
                    <li v-for="(item, index) in featuresCanUnlock" :key="index" class="d-flex align-items-center gap-2">
                        <div class="icon flex-shrink-0">
                            <img src="/img/x.svg" class="d-block" width="16" alt="X">
                        </div>
                        <span class="fs-14 d-block">{{ item }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="d-inline-flex gap-2 flex-wrap">
            <button @click="handleNextStep" class="btn btn-success fw-normal fs-6 px-4 py-12 continue-button">Continue</button>
            <button class="btn btn-light fw-normal px-4 py-12 text-gray-700 upgrade-button" @click="navigateToBilling">Upgrade Now</button>
        </div>
    </div>
</template>

<script>

import { ROUTES } from '../../utils/constants'

export default {
    name: "Screen1",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        handleNextStep: {
            type: Function,
            required: true
        },
        featuresCanUnlock: {
            type: Array,
            required: true
        },
        featuresIncludes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            userName:  _.get(this, '$A.Auth.name', '')
        }
    },
    methods: {
        navigateToBilling() {
            this.$router.push(ROUTES.BILLING);
        }
    }
};
</script>

<style scoped>
.features-list{
    border-bottom: 1px solid #EBEBED;
}

.screen-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 4rem;
}

.step-indicator {
    font-weight: 700;
}

.welcome-title {
    font-weight: 800;
}

.welcome-description {
    font-size: 16px;
}

.continue-button {
    font-weight: 400;
    color: #f9f9f9;
    font-size: 16px;
}

.upgrade-button {
    font-weight: 400;
    border: 1px solid #b5b5b8;
    font-size: 16px;
    background-color: white;
}
</style>
